import React, { useState, useEffect, useCallback } from "react";
import {
  Table,
  Button,
  ButtonGroup,
  Pagination,
  PaginationItem,
  PaginationLink,
  Form,
  Row,
  Col,
  FormGroup,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
  Input,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faWrench,
  faExclamationTriangle,
  faEyeSlash,
  faRedo,
  faSms,
} from "@fortawesome/free-solid-svg-icons";
import confirm from "reactstrap-confirm";
import Loader from "../../components/Loader";
import ActiveTries from "../../components/ActiveTries/index.jsx";
import api from "../../services/client/api";
import cookie from "../../services/cookie/index";
import { useHistory } from "react-router-dom";
import { deleteCookies } from "../../utils/functions";

function Users({ openUpdateUser }) {

  useEffect(() => {
    document.title = "Área Paciente | Painel Admin";
  }, []);
  let [page, setPage] = useState(1);
  let [qtdPages, setQtdPages] = useState(0);
  let [search, setSearch] = useState("");
  let [inProgress, setInProgress] = useState(true);
  let [users, setUsers] = useState([]);
  let [usersFound, setUsersFound] = useState([]);
  let history = useHistory();
  const ns = (field) => (field?.Valid ? field.String : "");
 const [showActiveTries, setShowActiveTries] = useState(false);
   const [selectedUser, setSelectedUser] = useState(null);
  const qtdPerPage = 15;
  const maskCPF = (cpf) => {
    if (!cpf) return "";
    return cpf
      .replace(/\D/g, "") // remove tudo que não é número
      .replace(/(\d{3})(\d)/, "$1.$2") // coloca o primeiro ponto
      .replace(/(\d{3})(\d)/, "$1.$2") // coloca o segundo ponto
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2"); // coloca o hífen
  };

    const token =  cookie().get("tokenAdm");


  useEffect(() => {}, [usersFound]);

  useEffect(() => {
    if (search !== "") {
      let usersSearching = users.filter(
        (user) =>
          user.name.includes(search) ||
          maskCPF(user.cpf).includes(search) ||
          user.cpf.includes(search) ||
          ns(user.email).includes(search),
      );

      setUsersFound(usersSearching);
      setQtdPages(Math.round(usersSearching.length / 15));
      setPage(1);
      return;
    }

    setPage(1);
    setQtdPages(Math.round(users.length / 15));
    setUsersFound(users);
  }, [search, setUsersFound, users]);

  const getAllUsers = useCallback(async () => {
    await setInProgress(true);

    const token = await cookie().get("tokenAdm");

    const response = await api().user().getAllByPage(token);

    if (response.status === 401) {
      await deleteCookies();
      return history.push({ pathname: "/admin" });
    }

    if (response.status === 200) {
      const validUsers = response.output;
      setUsers(validUsers);
      setUsersFound(validUsers);
      setQtdPages(Math.round(validUsers.length / 15));
      setInProgress(false);

      return;
    }

    setInProgress(false);
    setUsers([]);
    setUsersFound([]);
  }, [history]); // ← add dependencies if needed

  useEffect(() => {
    if (users.length <= 0) {
      getAllUsers(page);
    }
  }, [getAllUsers, page, users.length]);

  const updateTries = async (cpf, name) => {
    let result = await confirm({
      title: "Reativar Tentativas de envio SMS",
      message: (
        <>
          Você tem certeza de que deseja reativar as tentativas de envio de SMS para o usuário <b>{name}</b>?
        </>
      ),
      cancelText: "Cancelar",
      cancelColor: "secondary",
      confirmText: "Ativar Tentativas",
      confirmColor: "primary",
    });

    if (result) {
          const data = {
      username: cpf, // CPF vai como username
      type: 2
    };
      await setInProgress(true);

      const token = await cookie().get("tokenAdm");
      let response;

      response =   await api().log().updateLog(token, data);

      if (response.status === 200) {
       alert("Ativação das tentativas de envio SMS realizada com sucesso!");
      }
      setInProgress(false);
    }
  };

  const updateBanned = async (id_user, name) => {
    let result = await confirm({
      title: "Ocultar o usuário da lista",
      message: (
        <>
          Ocultar este usuário da listagem apenas remove sua prioridade no
          filtro; ainda será possível pesquisá-lo e editar suas informações.
          <br />
          <br />
          Você tem certeza de que deseja ocultar o usuário <b>{name}</b> da
          listagem?
        </>
      ),
      cancelText: "Cancelar",
      cancelColor: "secondary",
      confirmText: "Ocultar",
      confirmColor: "danger",
    });

    if (result) {
      await setInProgress(true);

      const token = await cookie().get("tokenAdm");
      const username = await cookie().get("username");

      let response;

      response = await api().userPatient().ban(token, id_user, username);

      if (response.status === 200) {
        return history.go(0);
      }
      setInProgress(false);
    }
  };

    const handleShowActiveTries = (username) => {
    setSelectedUser(username);
    setShowActiveTries(true);
  };

  const handleCloseActiveTries = () => {
    setShowActiveTries(false);
  };



  const PaginationComponent = () => {
    let element = [];

    for (let index = page - 3; index < page; index++) {
      let thisPage = index;
      if (thisPage > 0) {
        element.push(
          <PaginationItem active={thisPage === page}>
            <PaginationLink onClick={() => setPage(thisPage)}>
              {thisPage}
            </PaginationLink>
          </PaginationItem>,
        );
      }
    }

    for (let index = page - 1; index < qtdPages && index < page + 3; index++) {
      let thisPage = index + 1;
      element.push(
        <PaginationItem active={thisPage === page}>
          <PaginationLink onClick={() => setPage(thisPage)}>
            {thisPage}
          </PaginationLink>
        </PaginationItem>,
      );
    }

    return (
      <Pagination aria-label="">
        <PaginationItem>
          <PaginationLink
            first
            onClick={() => setPage(1)}
            disabled={page === 1}
          />
        </PaginationItem>

        <PaginationItem disabled={page === 1}>
          <PaginationLink previous onClick={() => setPage(page - 1)} />
        </PaginationItem>

        {element.map((e) => e)}

        <PaginationItem disabled={page === qtdPages}>
          <PaginationLink next onClick={() => setPage(page + 1)} />
        </PaginationItem>

        <PaginationItem disabled={page === qtdPages}>
          <PaginationLink last onClick={() => setPage(qtdPages)} />
        </PaginationItem>
      </Pagination>
    );
  };

  return (
    <div>
      <Form>
        <Row>
          <Col md={6}>
            <FormGroup>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>Buscar Usuário</InputGroupText>
                </InputGroupAddon>

                <Input
                  onChange={(e) => setSearch(e.target.value)}
                  value={search}
                  required
                  type="text"
                />
              </InputGroup>
            </FormGroup>
          </Col>
          <Col> <Button
                        color="secondary"
                        title="Reativar tentativas"
                        
                        onClick={() =>  handleShowActiveTries()}
                      >
                        Reativar Biometria <FontAwesomeIcon icon={faRedo} />
                      </Button></Col>
          
        </Row>
        
      </Form>
                

      {inProgress && <Loader />}

      <Table striped bordered responsive>
        <thead>
          <tr>
            <th>#</th>
            <th>Nome</th>
            <th>Cod. Paciente</th>
            <th>Nome Mãe</th>
            <th>CPF</th>
            <th>Data Nascimento</th>
            <th>Telefone</th>
            <th>E-mail</th>
            <th>Funções</th>
          </tr>
        </thead>
        <tbody>
          {usersFound
            .sort((a, b) => {
              const aPriority =
                (!a.code_patient || a.code_patient === "") &&
                a.revogado === false;
              const bPriority =
                (!b.code_patient || b.code_patient === "") &&
                b.revogado === false;

              if (aPriority && !bPriority) return -1;
              if (bPriority && !aPriority) return 1;

              return 0;
            })

            .slice(qtdPerPage * (page - 1), qtdPerPage * page)
            .map((user) => (
              <tr key={user.cpf}>
                <th scope="row">{user.id_user}</th>
                <th scope="row">{user.name}</th>

                <td>
                  {user.code_patient ? (
                    user.code_patient
                  ) : user.revogado ? (
                    "" // revogado = true → não mostra nada
                  ) : (
                    <center>
                      <FontAwesomeIcon
                        icon={faExclamationTriangle}
                        color="orange"
                        style={{ fontSize: "20px" }}
                      />
                    </center>
                  )}
                </td>
                <td>{ns(user.mother_name)}</td>
                <td style={{ whiteSpace: "nowrap" }}>{maskCPF(user.cpf)}</td>

                <td>
                  {user.birthday.split("T")[0].split("-").reverse().join("/")}
                </td>
                <td>{ns(user.tel)}</td>
                <td>{ns(user.email)}</td>

                <td>
                  <ButtonGroup>
                    <Button
                      color="primary"
                      onClick={() =>
                        openUpdateUser(
                          user.id_user,
                          user.name,
                          user.code_patient,
                          user.cpf,
                          ns(user.mother_name),
                          user.birthday
                            .split("T")[0]
                            .split("-")
                            .reverse()
                            .join("/"),
                          ns(user.tel),
                          ns(user.email),
                          user.id_categoria,
                        )
                      }
                    >
                      <FontAwesomeIcon icon={faWrench} />
                    </Button>
                 

                    {!user.code_patient && user.revogado === false && (
                      <Button
                        color="dark"
                        title="Ocultar usuário da listagem"
                        onClick={() => updateBanned(user.id_user, user.name)}
                      >
                        <FontAwesomeIcon icon={faEyeSlash} />
                      </Button>
                    )}
                         <Button
                        color="secondary"
                        title="Reativar tentativas"
                        
                        onClick={() =>  updateTries(user.cpf, user.name)}
                      >
                        <FontAwesomeIcon icon={faSms} />
                      </Button>
                  </ButtonGroup>
                </td>
              </tr>
            ))}
        </tbody>
      </Table>

      <PaginationComponent />
           {showActiveTries &&
                            (
                              <ActiveTries
                                token={token}
                                username={selectedUser}
                                onClose={handleCloseActiveTries}
                              />
                            )}
      
    </div>
    
  );
}

export default Users;
